"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.toolDef = void 0;
exports.handle = handle;
const fs = __importStar(require("fs-extra"));
const dist_1 = require("../../../fs/dist");
const chatNew_1 = require("../../../app/dist/chatNew");
exports.toolDef = {
    name: 'loom_create_chat',
    description: 'Create a new chat document in one of the two canonical chat homes. Thread chat: pass weave_slug + thread_ulid (the thread\'s stable th_ ULID) → {weave}/{thread}/chats. Refs chat: pass chatType="refs" → refs/chats. A non-refs chat with no resolvable thread errors — there is no weave-root chat.',
    inputSchema: {
        type: 'object',
        properties: {
            chatType: { type: 'string', enum: ['thread', 'refs'], description: 'Chat level: "thread" for thread-scoped chats, "refs" for reference chats at loom/refs/chats/' },
            weave_slug: { type: 'string', description: 'Target weave folder slug (required for thread chats)' },
            thread_ulid: { type: 'string', description: 'Stable th_ ULID of the thread (required for thread chats)' },
            title: { type: 'string', description: 'Optional chat title' },
        },
        required: [],
    },
};
async function handle(root, args) {
    const chatType = args['chatType'];
    const input = {
        weaveSlug: chatType === 'refs' ? 'refs' : args['weave_slug'],
        threadUlid: chatType === 'refs' ? undefined : args['thread_ulid'],
        title: args['title'],
    };
    const result = await (0, chatNew_1.chatNew)(input, {
        saveDoc: dist_1.saveDoc,
        loadDoc: dist_1.loadDoc,
        fs,
        loomRoot: root,
    });
    return { content: [{ type: 'text', text: JSON.stringify(result) }] };
}
